const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'membership_app_download',
    viewClass: require('./view'),
    modelClass: require('./model'),
    methods: {},
});
